import React from 'react';

import Link from '@/components/switchback/Link/Link';
import Tag, { TagSizes } from '@/components/switchback/Tag/Tag';
interface IArticleTags {
  id: string | null;
  name: string | null;
  slug: string | null;
}
interface ITagProps {
  tags?: IArticleTags[];
  className?: string;
  categoryTag?: boolean;
}
const Tags: React.FC<ITagProps> = ({ tags, categoryTag }) => {
  if (!tags || !tags.length) {
    return null;
  }
  return (
    <>
      {tags.map(tag => {
        return (
          <Tag size={TagSizes.small} className="mx-1 my-1" key={tag.id}>
            {categoryTag ? (
              <Link legacy href={`/help/category-tag/${tag.slug}/${tag.id}`}>
                <a>{tag.name}</a>
              </Link>
            ) : (
              <Link legacy href={`/help/category/${tag.slug}/${tag.id}`}>
                <a>{tag.name}</a>
              </Link>
            )}
          </Tag>
        );
      })}
    </>
  );
};

export default Tags;
